import { Injectable } from '@angular/core';

// Импорты локальных файлов перевода
import { de } from '@rpgc-ai/i18n/de';
import { en } from '@rpgc-ai/i18n/en';
import { ru } from '@rpgc-ai/i18n/ru';
import { ua } from '@rpgc-ai/i18n/ua';

import type { Translation, TranslocoLoader } from '@jsverse/transloco';
import { type Observable, of } from 'rxjs';

import { getSafeLanguageCode, type SupportedLanguageCode } from './languages';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  readonly #localTranslations: Record<SupportedLanguageCode, Translation> = {
    en,
    ru,
    ua,
    de,
  };

  /**
   * Запрашивает переводы, если ошибка - берет локальные
   * @param lang требуемый язык
   * @returns переводы
   */
  getTranslation(lang: SupportedLanguageCode): Observable<Translation> {
    return this.#getLocalTranslation(lang);
    // Если появится бэк для локализаций - раскомментить
    // return this.#http.get<Translation>(`${this.#API_BASE_URL}/${lang}`).pipe(
    //   catchError(() => {
    //     return this.#getLocalTranslation(lang);
    //   }),
    // );
  }

  /**
   * Берет переводы из локальных файлов, если нужного нет - берет английский
   * @param lang требуемый язык
   * @returns локальные переводы
   */
  #getLocalTranslation(lang: SupportedLanguageCode): Observable<Translation> {
    const translation = this.#localTranslations[getSafeLanguageCode(lang)];
    return of(translation);
  }
}
